module.exports = __webpack_public_path__ + "static/zoe-web-arm-745c3d1fb5249b418483b962a566d098.jpg";